"use strict";
/**
 * ProfileJson and sub-interfaces - shared between server and client.
 * These are pure JSON shapes (no Date objects) that describe the profile_json column.
 */
Object.defineProperty(exports, "__esModule", { value: true });
